export const sdoCSV: string = `start_date,end_date,max_date,max_speed
2010-05-16 09:00:00,2010-05-17 22:00:00,2010-05-16 09:00:00, 513.2
2010-05-19 03:00:00,2010-05-23 07:00:00,2010-05-20 09:00:00, 579.2
2010-05-30 21:00:00,2010-06-02 14:00:00,2010-05-31 11:00:00, 448.4
2010-06-03 18:00:00,2010-06-04 20:00:00,2010-06-04 01:00:00, 429.7
2010-06-07 15:00:00,2010-06-10 16:00:00,2010-06-08 14:00:00, 556.0
2010-06-15 05:00:00,2010-06-21 00:00:00,2010-06-16 01:00:00, 648.8
2010-06-25 18:00:00,2010-07-04 06:00:00,2010-06-27 11:00:00, 563.4
2010-07-13 12:00:00,2010-07-17 04:00:00,2010-07-13 16:00:00, 522.0
2010-07-22 12:00:00,2010-08-01 19:00:00,2010-07-29 21:00:00, 558.4
2010-08-09 06:00:00,2010-08-12 09:00:00,2010-08-11 01:00:00, 438.0
2010-08-14 20:00:00,2010-08-16 06:00:00,2010-08-15 12:00:00, 439.6
2010-08-24 13:00:00,2010-08-29 13:00:00,2010-08-26 10:00:00, 599.9
2010-09-04 13:00:00,2010-09-08 13:00:00,2010-09-05 15:00:00, 580.1
2010-09-20 21:00:00,2010-09-29 04:00:00,2010-09-22 03:00:00, 598.9
2010-10-03 11:00:00,2010-10-05 14:00:00,2010-10-04 08:00:00, 454.3
2010-10-20 00:00:00,2010-10-28 04:00:00,2010-10-24 14:00:00, 579.4
2010-10-30 13:00:00,2010-11-04 02:00:00,2010-10-31 11:00:00, 451.2
2010-11-14 17:00:00,2010-11-18 09:00:00,2010-11-16 10:00:00, 504.6
2010-12-07 05:00:00,2010-12-08 19:00:00,2010-12-07 13:00:00, 444.1
2010-12-09 23:00:00,2010-12-21 07:00:00,2010-12-11 02:00:00, 533.5
2010-12-27 20:00:00,2010-12-31 12:00:00,2010-12-29 18:00:00, 484.5
2011-01-06 04:00:00,2011-01-11 08:00:00,2011-01-07 14:00:00, 615.3
2011-01-12 18:00:00,2011-01-19 18:00:00,2011-01-13 15:00:00, 599.5
2011-02-02 15:00:00,2011-02-07 17:00:00,2011-02-04 07:00:00, 637.4
2011-02-12 22:00:00,2011-02-16 09:00:00,2011-02-15 00:00:00, 461.6
2011-02-23 14:00:00,2011-02-25 19:00:00,2011-02-23 21:00:00, 522.4
2011-03-02 13:00:00,2011-03-07 02:00:00,2011-03-03 21:00:00, 634.1
2011-03-09 06:00:00,2011-03-10 23:00:00,2011-03-10 17:00:00, 429.0
2011-03-12 05:00:00,2011-03-16 13:00:00,2011-03-13 13:00:00, 535.2
2011-03-22 03:00:00,2011-03-25 09:00:00,2011-03-23 01:00:00, 501.2
2011-03-29 22:00:00,2011-04-01 07:00:00,2011-03-31 01:00:00, 498.1
2011-04-03 22:00:00,2011-04-07 06:00:00,2011-04-04 09:00:00, 542.3
2011-04-11 03:00:00,2011-04-14 00:00:00,2011-04-12 03:00:00, 485.6
2011-04-19 13:00:00,2011-04-22 06:00:00,2011-04-20 14:00:00, 494.0
2011-04-26 02:00:00,2011-05-04 08:00:00,2011-05-01 04:00:00, 594.2
2011-05-05 23:00:00,2011-05-07 18:00:00,2011-05-06 01:00:00, 489.9
2011-05-09 21:00:00,2011-05-11 02:00:00,2011-05-10 11:00:00, 442.3
2011-05-14 17:00:00,2011-05-19 03:00:00,2011-05-17 20:00:00, 461.7
2011-05-27 09:00:00,2011-05-30 22:00:00,2011-05-27 21:00:00, 554.1
2011-06-03 11:00:00,2011-06-09 04:00:00,2011-06-04 22:00:00, 554.4
2011-06-14 13:00:00,2011-06-15 22:00:00,2011-06-14 15:00:00, 457.9
2011-06-20 12:00:00,2011-06-25 18:00:00,2011-06-24 06:00:00, 572.3
2011-06-30 15:00:00,2011-07-03 20:00:00,2011-07-02 04:00:00, 501.3
2011-07-05 01:00:00,2011-07-07 12:00:00,2011-07-05 12:00:00, 449.2
2011-07-08 22:00:00,2011-07-14 00:00:00,2011-07-12 11:00:00, 507.4
2011-07-17 16:00:00,2011-07-24 08:00:00,2011-07-19 04:00:00, 633.6
2011-07-29 21:00:00,2011-08-01 12:00:00,2011-07-30 18:00:00, 496.8
2011-08-07 08:00:00,2011-08-10 22:00:00,2011-08-07 18:00:00, 548.6
2011-08-14 02:00:00,2011-08-19 04:00:00,2011-08-15 19:00:00, 578.8
2011-08-21 06:00:00,2011-08-25 20:00:00,2011-08-22 00:00:00, 569.1
2011-08-27 01:00:00,2011-08-30 14:00:00,2011-08-28 01:00:00, 553.2
2011-09-04 08:00:00,2011-09-07 08:00:00,2011-09-05 07:00:00, 507.2
2011-09-11 02:00:00,2011-09-15 11:00:00,2011-09-11 21:00:00, 590.6
2011-09-23 13:00:00,2011-09-26 14:00:00,2011-09-23 23:00:00, 490.7
2011-10-01 15:00:00,2011-10-05 18:00:00,2011-10-02 19:00:00, 518.9
2011-10-07 06:00:00,2011-10-12 16:00:00,2011-10-09 14:00:00, 480.5
2011-10-14 22:00:00,2011-10-18 16:00:00,2011-10-16 01:00:00, 578.4
2011-10-21 11:00:00,2011-10-25 17:00:00,2011-10-22 17:00:00, 476.8
2011-10-28 18:00:00,2011-10-31 14:00:00,2011-10-29 20:00:00, 509.1
2011-11-12 16:00:00,2011-11-15 12:00:00,2011-11-13 01:00:00, 468.5
2011-11-18 20:00:00,2011-11-21 02:00:00,2011-11-19 18:00:00, 449.1
2011-11-25 19:00:00,2011-11-26 22:00:00,2011-11-26 03:00:00, 429.8
2011-11-28 20:00:00,2011-12-06 22:00:00,2011-12-03 07:00:00, 489.6
2011-12-13 18:00:00,2011-12-14 15:00:00,2011-12-13 22:00:00, 452.4
2011-12-20 06:00:00,2011-12-23 11:00:00,2011-12-21 13:00:00, 457.5
2011-12-29 21:00:00,2012-01-03 17:00:00,2011-12-31 14:00:00, 543.0
2012-01-05 22:00:00,2012-01-18 10:00:00,2012-01-07 09:00:00, 548.2
2012-01-21 17:00:00,2012-01-23 17:00:00,2012-01-22 09:00:00, 441.1
2012-01-27 03:00:00,2012-02-07 08:00:00,2012-01-27 17:00:00, 570.3
2012-02-09 14:00:00,2012-02-12 23:00:00,2012-02-10 04:00:00, 554.9
2012-02-14 09:00:00,2012-02-15 14:00:00,2012-02-14 12:00:00, 435.8
2012-02-18 00:00:00,2012-02-21 14:00:00,2012-02-19 17:00:00, 543.3
2012-02-24 01:00:00,2012-02-28 19:00:00,2012-02-25 12:00:00, 521.1
2012-03-03 12:00:00,2012-03-05 19:00:00,2012-03-03 21:00:00, 478.7
2012-03-06 11:00:00,2012-03-11 16:00:00,2012-03-09 22:00:00, 650.9
2012-03-13 00:00:00,2012-03-13 15:00:00,2012-03-13 02:00:00, 451.9
2012-03-15 09:00:00,2012-03-19 20:00:00,2012-03-16 01:00:00, 661.0
2012-03-23 01:00:00,2012-03-24 21:00:00,2012-03-23 04:00:00, 448.1
2012-03-27 07:00:00,2012-03-30 13:00:00,2012-03-27 18:00:00, 507.0
2012-04-02 18:00:00,2012-04-06 13:00:00,2012-04-04 10:00:00, 507.4
2012-04-11 16:00:00,2012-04-16 12:00:00,2012-04-12 16:00:00, 626.6
2012-04-17 06:00:00,2012-04-18 15:00:00,2012-04-17 07:00:00, 427.3
2012-04-24 18:00:00,2012-04-27 10:00:00,2012-04-25 23:00:00, 435.8
2012-04-28 09:00:00,2012-05-02 14:00:00,2012-04-30 21:00:00, 500.4
2012-05-08 18:00:00,2012-05-17 20:00:00,2012-05-09 12:00:00, 645.9
2012-05-22 06:00:00,2012-05-29 14:00:00,2012-05-26 10:00:00, 494.9
2012-05-31 09:00:00,2012-06-02 15:00:00,2012-06-01 23:00:00, 439.6
2012-06-04 23:00:00,2012-06-10 10:00:00,2012-06-05 19:00:00, 657.3
2012-06-12 21:00:00,2012-06-15 09:00:00,2012-06-13 03:00:00, 520.2
2012-06-20 09:00:00,2012-06-24 01:00:00,2012-06-20 22:00:00, 539.5
2012-07-01 14:00:00,2012-07-08 02:00:00,2012-07-02 21:00:00, 659.7
2012-07-09 15:00:00,2012-07-13 13:00:00,2012-07-10 14:00:00, 569.7
2012-07-17 04:00:00,2012-07-20 06:00:00,2012-07-17 18:00:00, 513.1
2012-07-23 12:00:00,2012-07-25 20:00:00,2012-07-23 22:00:00, 505.7
2012-07-28 04:00:00,2012-08-06 00:00:00,2012-07-30 09:00:00, 580.6
2012-08-06 14:00:00,2012-08-12 07:00:00,2012-08-09 21:00:00, 520.7
2012-08-18 13:00:00,2012-08-21 21:00:00,2012-08-19 02:00:00, 516.6
2012-08-22 22:00:00,2012-08-31 01:00:00,2012-08-26 01:00:00, 542.3
2012-09-01 00:00:00,2012-09-02 03:00:00,2012-09-01 18:00:00, 425.6
2012-09-06 02:00:00,2012-09-07 17:00:00,2012-09-06 12:00:00, 445.6
2012-09-11 17:00:00,2012-09-14 02:00:00,2012-09-12 00:00:00, 456.6
2012-09-17 20:00:00,2012-09-26 20:00:00,2012-09-22 10:00:00, 517.1
2012-09-30 19:00:00,2012-10-03 08:00:00,2012-10-01 19:00:00, 495.4
2012-10-08 01:00:00,2012-10-11 07:00:00,2012-10-09 11:00:00, 512.4
2012-10-13 12:00:00,2012-10-25 08:00:00,2012-10-20 23:00:00, 545.5
2012-10-27 12:00:00,2012-10-30 23:00:00,2012-10-28 08:00:00, 515.2
2012-11-04 03:00:00,2012-11-06 22:00:00,2012-11-04 23:00:00, 462.9
2012-11-13 00:00:00,2012-11-20 19:00:00,2012-11-13 10:00:00, 490.1
2012-11-22 15:00:00,2012-11-27 05:00:00,2012-11-24 14:00:00, 463.3
2012-11-30 00:00:00,2012-12-03 11:00:00,2012-11-30 16:00:00, 506.5
2012-12-09 23:00:00,2012-12-11 01:00:00,2012-12-10 05:00:00, 449.1
2012-12-13 01:00:00,2012-12-19 18:00:00,2012-12-16 20:00:00, 524.2
2012-12-22 19:00:00,2012-12-24 18:00:00,2012-12-23 04:00:00, 452.9
2012-12-26 08:00:00,2013-01-01 17:00:00,2012-12-27 10:00:00, 501.2
2013-01-06 17:00:00,2013-01-14 16:00:00,2013-01-08 10:00:00, 539.4
2013-01-24 23:00:00,2013-01-27 15:00:00,2013-01-25 19:00:00, 467.6
2013-02-02 21:00:00,2013-02-12 04:00:00,2013-02-05 10:00:00, 563.7
2013-02-14 14:00:00,2013-02-20 17:00:00,2013-02-15 10:00:00, 481.4
2013-02-22 22:00:00,2013-02-24 04:00:00,2013-02-23 02:00:00, 472.5
2013-03-01 08:00:00,2013-03-04 20:00:00,2013-03-01 12:00:00, 494.8
2013-03-06 13:00:00,2013-03-11 20:00:00,2013-03-07 12:00:00, 581.2
2013-03-14 11:00:00,2013-03-23 10:00:00,2013-03-19 08:00:00, 493.6
2013-03-28 04:00:00,2013-04-02 14:00:00,2013-03-29 10:00:00, 526.4
2013-04-04 03:00:00,2013-04-13 06:00:00,2013-04-04 18:00:00, 565.4
2013-04-14 14:00:00,2013-04-15 18:00:00,2013-04-15 03:00:00, 463.3
2013-04-20 05:00:00,2013-04-22 20:00:00,2013-04-20 20:00:00, 509.6
2013-04-24 06:00:00,2013-04-29 17:00:00,2013-04-26 08:00:00, 587.0
2013-05-01 17:00:00,2013-05-09 03:00:00,2013-05-07 04:00:00, 576.0
2013-05-12 02:00:00,2013-05-15 08:00:00,2013-05-12 11:00:00, 502.2
2013-05-16 17:00:00,2013-05-20 22:00:00,2013-05-17 01:00:00, 464.1
2013-05-23 02:00:00,2013-05-29 10:00:00,2013-05-24 22:00:00, 524.1
2013-05-31 09:00:00,2013-06-05 14:00:00,2013-06-01 02:00:00, 643.6
2013-06-07 07:00:00,2013-06-11 17:00:00,2013-06-07 22:00:00, 535.4
2013-06-19 05:00:00,2013-07-01 19:00:00,2013-06-28 02:00:00, 636.3
2013-07-05 08:00:00,2013-07-09 01:00:00,2013-07-06 16:00:00, 535.7
2013-07-17 05:00:00,2013-07-30 01:00:00,2013-07-24 16:00:00, 621.0
2013-08-02 13:00:00,2013-08-07 17:00:00,2013-08-03 08:00:00, 536.4
2013-08-08 13:00:00,2013-08-10 13:00:00,2013-08-08 19:00:00, 442.5
2013-08-15 00:00:00,2013-08-28 13:00:00,2013-08-17 11:00:00, 597.2
2013-08-29 16:00:00,2013-09-02 14:00:00,2013-08-30 03:00:00, 581.8
2013-09-03 14:00:00,2013-09-06 17:00:00,2013-09-05 05:00:00, 502.0
2013-09-12 11:00:00,2013-09-19 18:00:00,2013-09-13 00:00:00, 497.6
2013-09-22 00:00:00,2013-09-25 07:00:00,2013-09-23 00:00:00, 507.4
2013-09-30 22:00:00,2013-10-04 03:00:00,2013-10-02 04:00:00, 472.8
2013-10-06 19:00:00,2013-10-17 17:00:00,2013-10-13 11:00:00, 539.6
2013-10-20 09:00:00,2013-10-22 23:00:00,2013-10-20 17:00:00, 495.9
2013-10-25 00:00:00,2013-10-27 09:00:00,2013-10-26 03:00:00, 459.8
2013-11-01 17:00:00,2013-11-13 05:00:00,2013-11-10 01:00:00, 521.6
2013-11-14 03:00:00,2013-11-20 09:00:00,2013-11-16 11:00:00, 574.5
2013-11-30 09:00:00,2013-12-01 14:00:00,2013-12-01 04:00:00, 424.3
2013-12-06 06:00:00,2013-12-10 15:00:00,2013-12-07 00:00:00, 528.9
2013-12-13 00:00:00,2013-12-18 03:00:00,2013-12-14 08:00:00, 618.4
2013-12-24 07:00:00,2013-12-28 12:00:00,2013-12-25 05:00:00, 520.2
2014-01-01 03:00:00,2014-01-06 20:00:00,2014-01-03 08:00:00, 593.4
2014-01-09 13:00:00,2014-01-18 12:00:00,2014-01-12 08:00:00, 605.9
2014-01-21 06:00:00,2014-01-26 04:00:00,2014-01-22 02:00:00, 530.6
2014-01-29 13:00:00,2014-01-30 15:00:00,2014-01-30 04:00:00, 434.8
2014-02-03 14:00:00,2014-02-05 11:00:00,2014-02-03 17:00:00, 489.0
2014-02-07 16:00:00,2014-02-12 07:00:00,2014-02-09 04:00:00, 602.9
2014-02-17 04:00:00,2014-02-20 17:00:00,2014-02-17 09:00:00, 514.2
2014-02-21 19:00:00,2014-02-24 08:00:00,2014-02-21 23:00:00, 475.1
2014-02-27 07:00:00,2014-03-05 11:00:00,2014-03-02 19:00:00, 589.6
2014-03-08 01:00:00,2014-03-12 02:00:00,2014-03-08 21:00:00, 624.4
2014-03-16 21:00:00,2014-03-19 09:00:00,2014-03-18 05:00:00, 487.2
2014-03-22 18:00:00,2014-03-26 20:00:00,2014-03-24 10:00:00, 538.0
2014-03-28 22:00:00,2014-04-04 03:00:00,2014-03-31 01:00:00, 501.8
2014-04-05 11:00:00,2014-04-08 10:00:00,2014-04-05 21:00:00, 484.1
2014-04-09 12:00:00,2014-04-11 01:00:00,2014-04-10 10:00:00, 431.5
2014-04-12 02:00:00,2014-04-17 23:00:00,2014-04-13 00:00:00, 566.6
2014-04-20 18:00:00,2014-04-23 02:00:00,2014-04-20 21:00:00, 434.8
2014-04-27 07:00:00,2014-04-29 20:00:00,2014-04-28 03:00:00, 469.7
2014-05-12 00:00:00,2014-05-17 23:00:00,2014-05-15 05:00:00, 537.7
2014-05-25 06:00:00,2014-05-30 04:00:00,2014-05-27 13:00:00, 503.2
2014-06-03 12:00:00,2014-06-06 03:00:00,2014-06-04 10:00:00, 433.1
2014-06-09 12:00:00,2014-06-21 16:00:00,2014-06-12 23:00:00, 542.8
2014-06-27 08:00:00,2014-07-01 12:00:00,2014-06-28 16:00:00, 476.5
2014-07-04 21:00:00,2014-07-06 05:00:00,2014-07-05 02:00:00, 449.2
2014-07-08 10:00:00,2014-07-15 10:00:00,2014-07-10 21:00:00, 594.4
2014-08-01 16:00:00,2014-08-16 02:00:00,2014-08-13 23:00:00, 492.4
2014-08-19 13:00:00,2014-08-20 06:00:00,2014-08-19 14:00:00, 454.8
2014-08-24 17:00:00,2014-09-15 15:00:00,2014-09-01 08:00:00, 562.0
2014-09-17 01:00:00,2014-10-09 01:00:00,2014-10-01 01:00:00, 560.7
2014-10-13 04:00:00,2014-10-16 13:00:00,2014-10-13 18:00:00, 474.3
2014-10-20 05:00:00,2014-10-27 02:00:00,2014-10-24 10:00:00, 561.5
2014-10-28 04:00:00,2014-11-05 00:00:00,2014-10-28 22:00:00, 524.2
2014-11-10 12:00:00,2014-11-13 15:00:00,2014-11-11 03:00:00, 553.4
2014-11-16 03:00:00,2014-11-22 01:00:00,2014-11-17 08:00:00, 578.8
2014-11-24 20:00:00,2014-11-28 14:00:00,2014-11-25 19:00:00, 508.3
2014-11-29 10:00:00,2014-12-03 07:00:00,2014-11-30 09:00:00, 527.8
2014-12-07 12:00:00,2014-12-10 19:00:00,2014-12-08 17:00:00, 477.8
2014-12-13 12:00:00,2014-12-19 09:00:00,2014-12-13 16:00:00, 600.3
2014-12-21 12:00:00,2014-12-29 23:00:00,2014-12-28 05:00:00, 526.4
2015-01-05 17:00:00,2015-01-07 21:00:00,2015-01-07 02:00:00, 467.5
2015-01-09 17:00:00,2015-01-16 02:00:00,2015-01-10 14:00:00, 608.2
2015-01-17 04:00:00,2015-01-24 08:00:00,2015-01-19 04:00:00, 555.7
2015-01-25 11:00:00,2015-01-26 12:00:00,2015-01-25 15:00:00, 477.8
2015-02-01 22:00:00,2015-02-05 17:00:00,2015-02-02 01:00:00, 501.9
2015-02-08 18:00:00,2015-02-12 04:00:00,2015-02-10 09:00:00, 548.0
2015-02-13 09:00:00,2015-02-22 04:00:00,2015-02-14 07:00:00, 593.9
2015-02-23 08:00:00,2015-02-27 00:00:00,2015-02-23 14:00:00, 505.6
2015-03-01 18:00:00,2015-03-28 01:00:00,2015-03-08 01:00:00, 578.3
2015-04-02 04:00:00,2015-04-12 08:00:00,2015-04-03 23:00:00, 633.1
2015-04-14 20:00:00,2015-04-17 05:00:00,2015-04-15 16:00:00, 508.1
2015-04-18 09:00:00,2015-04-19 19:00:00,2015-04-19 00:00:00, 450.6
2015-04-20 13:00:00,2015-04-29 13:00:00,2015-04-22 02:00:00, 514.0
2015-04-30 04:00:00,2015-05-07 08:00:00,2015-05-01 13:00:00, 607.9
2015-05-11 14:00:00,2015-05-21 07:00:00,2015-05-12 18:00:00, 557.4
2015-05-26 21:00:00,2015-06-02 03:00:00,2015-05-27 20:00:00, 594.9
2015-06-03 07:00:00,2015-06-05 17:00:00,2015-06-04 14:00:00, 433.0
2015-06-07 21:00:00,2015-06-20 11:00:00,2015-06-10 17:00:00, 600.2
2015-06-22 10:00:00,2015-06-29 11:00:00,2015-06-22 21:00:00, 566.4
2015-07-05 01:00:00,2015-07-14 04:00:00,2015-07-06 21:00:00, 579.8
2015-07-14 21:00:00,2015-07-17 09:00:00,2015-07-15 09:00:00, 464.1
2015-07-19 13:00:00,2015-07-22 12:00:00,2015-07-20 17:00:00, 506.6
2015-07-24 05:00:00,2015-07-30 00:00:00,2015-07-24 07:00:00, 495.9
2015-07-31 22:00:00,2015-08-06 05:00:00,2015-08-02 09:00:00, 567.1
2015-08-14 04:00:00,2015-08-18 10:00:00,2015-08-15 12:00:00, 529.0
2015-08-20 16:00:00,2015-08-26 22:00:00,2015-08-21 07:00:00, 544.3
2015-08-28 05:00:00,2015-09-04 10:00:00,2015-08-28 17:00:00, 591.7
2015-09-06 04:00:00,2015-09-09 04:00:00,2015-09-06 11:00:00, 485.7
2015-09-10 19:00:00,2015-09-21 00:00:00,2015-09-12 08:00:00, 568.2
2015-09-24 01:00:00,2015-09-29 05:00:00,2015-09-24 19:00:00, 612.9
2015-09-30 17:00:00,2015-10-02 14:00:00,2015-10-01 09:00:00, 448.4
2015-10-07 00:00:00,2015-10-18 23:00:00,2015-10-15 06:00:00, 650.6
2015-10-20 19:00:00,2015-10-25 17:00:00,2015-10-21 23:00:00, 624.2
2015-11-02 20:00:00,2015-11-06 14:00:00,2015-11-03 09:00:00, 549.0
2015-11-08 07:00:00,2015-11-21 16:00:00,2015-11-09 17:00:00, 650.5
2015-11-24 05:00:00,2015-11-28 20:00:00,2015-11-25 09:00:00, 520.9
2015-11-30 08:00:00,2015-12-03 00:00:00,2015-12-01 12:00:00, 522.9
2015-12-05 06:00:00,2015-12-20 02:00:00,2015-12-06 11:00:00, 613.0
2015-12-22 03:00:00,2015-12-23 05:00:00,2015-12-22 06:00:00, 442.4
2015-12-29 10:00:00,2015-12-30 14:00:00,2015-12-29 19:00:00, 433.1
2016-01-01 00:00:00,2016-01-10 00:00:00,2016-01-02 03:00:00, 611.8
2016-01-12 22:00:00,2016-01-15 11:00:00,2016-01-13 17:00:00, 465.3
2016-01-21 13:00:00,2016-01-22 14:00:00,2016-01-21 14:00:00, 457.4
2016-01-25 15:00:00,2016-01-28 02:00:00,2016-01-26 10:00:00, 494.8
2016-01-28 23:00:00,2016-02-01 06:00:00,2016-01-29 17:00:00, 547.0
2016-02-02 11:00:00,2016-02-05 11:00:00,2016-02-04 01:00:00, 490.8
2016-02-08 00:00:00,2016-02-10 12:00:00,2016-02-08 22:00:00, 452.3
2016-02-11 12:00:00,2016-02-12 16:00:00,2016-02-11 13:00:00, 417.1
2016-02-16 20:00:00,2016-02-20 03:00:00,2016-02-17 12:00:00, 548.2
2016-02-22 12:00:00,2016-03-03 18:00:00,2016-03-01 16:00:00, 547.0
2016-03-05 10:00:00,2016-03-08 05:00:00,2016-03-06 18:00:00, 454.8
2016-03-11 01:00:00,2016-03-13 15:00:00,2016-03-12 22:00:00, 467.3
2016-03-15 21:00:00,2016-03-19 12:00:00,2016-03-17 07:00:00, 491.6
2016-03-21 05:00:00,2016-03-25 11:00:00,2016-03-21 23:00:00, 577.6
2016-03-27 00:00:00,2016-03-31 00:00:00,2016-03-28 02:00:00, 596.3
2016-04-05 03:00:00,2016-04-08 05:00:00,2016-04-05 11:00:00, 462.0
2016-04-12 16:00:00,2016-04-15 13:00:00,2016-04-13 06:00:00, 513.5
2016-04-18 11:00:00,2016-04-22 03:00:00,2016-04-19 12:00:00, 557.8
2016-04-23 03:00:00,2016-04-27 08:00:00,2016-04-24 03:00:00, 602.5
2016-04-30 00:00:00,2016-05-04 04:00:00,2016-05-01 00:00:00, 569.7
2016-05-06 05:00:00,2016-05-13 01:00:00,2016-05-10 01:00:00, 546.9
2016-05-15 14:00:00,2016-05-24 09:00:00,2016-05-20 17:00:00, 584.3
2016-05-26 13:00:00,2016-05-31 16:00:00,2016-05-28 10:00:00, 545.5
2016-06-04 23:00:00,2016-06-08 14:00:00,2016-06-05 20:00:00, 522.5
2016-06-10 21:00:00,2016-06-20 16:00:00,2016-06-16 02:00:00, 636.9
2016-06-22 00:00:00,2016-06-27 23:00:00,2016-06-22 23:00:00, 540.2
2016-06-30 05:00:00,2016-07-05 11:00:00,2016-07-02 16:00:00, 497.7
2016-07-07 20:00:00,2016-07-17 08:00:00,2016-07-13 13:00:00, 607.2
2016-07-19 03:00:00,2016-07-25 02:00:00,2016-07-22 10:00:00, 529.6
2016-07-28 02:00:00,2016-07-31 13:00:00,2016-07-28 05:00:00, 517.7
2016-08-02 12:00:00,2016-08-17 17:00:00,2016-08-03 15:00:00, 551.8
2016-08-19 10:00:00,2016-08-22 02:00:00,2016-08-20 07:00:00, 476.5
2016-08-23 16:00:00,2016-08-27 03:00:00,2016-08-25 12:00:00, 491.6
2016-08-29 12:00:00,2016-09-01 00:00:00,2016-08-30 05:00:00, 492.1
2016-09-01 16:00:00,2016-09-08 21:00:00,2016-09-03 07:00:00, 634.4
2016-09-10 08:00:00,2016-09-14 02:00:00,2016-09-11 07:00:00, 477.8
2016-09-16 02:00:00,2016-09-17 13:00:00,2016-09-16 18:00:00, 446.9
2016-09-19 11:00:00,2016-09-23 12:00:00,2016-09-20 15:00:00, 578.0
2016-09-26 02:00:00,2016-09-27 21:00:00,2016-09-26 21:00:00, 433.1
2016-09-28 15:00:00,2016-10-05 15:00:00,2016-09-29 22:00:00, 613.3
2016-10-14 07:00:00,2016-10-20 01:00:00,2016-10-16 06:00:00, 587.2
2016-10-25 12:00:00,2016-11-02 01:00:00,2016-10-28 13:00:00, 688.8
2016-11-04 16:00:00,2016-11-05 16:00:00,2016-11-04 22:00:00, 425.6
2016-11-11 02:00:00,2016-11-17 02:00:00,2016-11-12 19:00:00, 615.9
2016-11-18 09:00:00,2016-11-20 14:00:00,2016-11-18 19:00:00, 472.3
2016-11-22 22:00:00,2016-11-29 23:00:00,2016-11-25 05:00:00, 577.9
2016-12-05 07:00:00,2016-12-06 09:00:00,2016-12-05 19:00:00, 416.7
2016-12-08 08:00:00,2016-12-14 04:00:00,2016-12-09 10:00:00, 632.4
2016-12-17 13:00:00,2016-12-28 01:00:00,2016-12-22 17:00:00, 611.9
2016-12-31 00:00:00,2017-01-03 04:00:00,2016-12-31 18:00:00, 518.7
2017-01-04 10:00:00,2017-01-09 01:00:00,2017-01-05 16:00:00, 662.5
2017-01-11 01:00:00,2017-01-14 00:00:00,2017-01-11 02:00:00, 467.3
2017-01-18 00:00:00,2017-01-24 15:00:00,2017-01-19 09:00:00, 578.1
2017-01-26 18:00:00,2017-01-30 18:00:00,2017-01-27 19:00:00, 575.5
2017-01-31 23:00:00,2017-02-05 08:00:00,2017-02-02 03:00:00, 630.3
2017-02-07 14:00:00,2017-02-10 15:00:00,2017-02-08 00:00:00, 477.7
2017-02-14 18:00:00,2017-02-26 02:00:00,2017-02-24 05:00:00, 585.6
2017-02-28 10:00:00,2017-03-05 03:00:00,2017-03-01 21:00:00, 615.1
2017-03-12 19:00:00,2017-03-13 17:00:00,2017-03-12 20:00:00, 489.2
2017-03-21 10:00:00,2017-04-01 01:00:00,2017-03-22 12:00:00, 669.9
2017-04-02 14:00:00,2017-04-05 02:00:00,2017-04-02 18:00:00, 522.4
2017-04-09 09:00:00,2017-04-11 08:00:00,2017-04-09 14:00:00, 482.1
2017-04-17 11:00:00,2017-04-22 05:00:00,2017-04-18 18:00:00, 511.1
2017-04-23 01:00:00,2017-04-29 11:00:00,2017-04-24 16:00:00, 625.4
2017-05-15 12:00:00,2017-05-18 05:00:00,2017-05-17 06:00:00, 501.5
2017-05-20 01:00:00,2017-05-25 04:00:00,2017-05-21 08:00:00, 591.7
2017-06-02 12:00:00,2017-06-04 16:00:00,2017-06-03 18:00:00, 427.7
2017-06-16 01:00:00,2017-06-21 01:00:00,2017-06-17 16:00:00, 595.3
2017-06-23 19:00:00,2017-06-26 10:00:00,2017-06-24 08:00:00, 498.9
2017-07-04 10:00:00,2017-07-06 15:00:00,2017-07-05 14:00:00, 429.2
2017-07-08 23:00:00,2017-07-12 10:00:00,2017-07-09 21:00:00, 561.4
2017-07-16 03:00:00,2017-07-18 22:00:00,2017-07-17 11:00:00, 488.2
2017-07-20 21:00:00,2017-08-03 09:00:00,2017-07-22 17:00:00, 548.3
2017-08-04 04:00:00,2017-08-07 14:00:00,2017-08-05 13:00:00, 615.3
2017-08-11 22:00:00,2017-08-15 12:00:00,2017-08-12 22:00:00, 495.6
2017-08-17 03:00:00,2017-09-05 10:00:00,2017-09-01 15:00:00, 604.0
2017-09-08 22:00:00,2017-09-11 09:00:00,2017-09-09 19:00:00, 458.1
2017-09-13 03:00:00,2017-09-18 01:00:00,2017-09-14 19:00:00, 532.5
2017-09-23 18:00:00,2017-09-26 01:00:00,2017-09-23 22:00:00, 483.8
2017-09-26 16:00:00,2017-10-01 07:00:00,2017-09-28 05:00:00, 609.8
2017-10-05 02:00:00,2017-10-08 09:00:00,2017-10-06 14:00:00, 533.5
2017-10-11 01:00:00,2017-10-15 12:00:00,2017-10-11 23:00:00, 491.5
2017-10-20 11:00:00,2017-10-23 05:00:00,2017-10-20 15:00:00, 490.1
2017-10-23 22:00:00,2017-10-27 16:00:00,2017-10-25 19:00:00, 522.9
2017-11-01 10:00:00,2017-11-04 11:00:00,2017-11-02 03:00:00, 533.2
2017-11-07 08:00:00,2017-11-11 14:00:00,2017-11-08 07:00:00, 478.5
2017-11-14 17:00:00,2017-11-23 01:00:00,2017-11-21 03:00:00, 532.4
2017-11-27 12:00:00,2017-12-02 00:00:00,2017-11-30 13:00:00, 506.6
2017-12-04 16:00:00,2017-12-08 08:00:00,2017-12-05 18:00:00, 523.6
2017-12-11 05:00:00,2017-12-12 22:00:00,2017-12-12 01:00:00, 444.7
2017-12-14 08:00:00,2017-12-20 05:00:00,2017-12-18 05:00:00, 496.0
2017-12-24 04:00:00,2017-12-29 15:00:00,2017-12-25 04:00:00, 527.1
2018-01-01 13:00:00,2018-01-04 06:00:00,2018-01-02 14:00:00, 487.4
2018-01-08 01:00:00,2018-01-10 05:00:00,2018-01-09 03:00:00, 485.8
2018-01-12 18:00:00,2018-01-15 16:00:00,2018-01-14 05:00:00, 453.4
2018-01-19 20:00:00,2018-01-23 17:00:00,2018-01-20 10:00:00, 523.6
2018-02-09 09:00:00,2018-02-10 12:00:00,2018-02-09 22:00:00, 431.5
2018-02-15 18:00:00,2018-02-20 21:00:00,2018-02-17 09:00:00, 556.5
2018-02-26 16:00:00,2018-02-28 07:00:00,2018-02-26 17:00:00, 428.7
2018-03-03 20:00:00,2018-03-05 09:00:00,2018-03-04 12:00:00, 468.8
2018-03-08 10:00:00,2018-03-11 00:00:00,2018-03-08 11:00:00, 547.8
2018-03-14 03:00:00,2018-03-20 01:00:00,2018-03-16 15:00:00, 550.6
2018-03-22 19:00:00,2018-03-27 15:00:00,2018-03-24 03:00:00, 514.3
2018-04-09 07:00:00,2018-04-13 21:00:00,2018-04-11 00:00:00, 530.9
2018-04-19 05:00:00,2018-04-23 01:00:00,2018-04-20 01:00:00, 577.7
2018-05-06 01:00:00,2018-05-12 08:00:00,2018-05-07 07:00:00, 577.7
2018-05-16 17:00:00,2018-05-18 14:00:00,2018-05-17 03:00:00, 478.7
2018-05-21 23:00:00,2018-05-24 18:00:00,2018-05-22 18:00:00, 520.2
2018-06-01 06:00:00,2018-06-06 02:00:00,2018-06-02 09:00:00, 552.7
2018-06-18 07:00:00,2018-06-20 03:00:00,2018-06-19 09:00:00, 464.2
2018-06-24 05:00:00,2018-06-27 01:00:00,2018-06-25 01:00:00, 461.7
2018-07-16 00:00:00,2018-07-17 07:00:00,2018-07-16 03:00:00, 425.6
2018-07-24 05:00:00,2018-07-29 22:00:00,2018-07-24 17:00:00, 513.5
2018-08-04 19:00:00,2018-08-05 19:00:00,2018-08-05 08:00:00, 429.1
2018-08-07 01:00:00,2018-08-08 17:00:00,2018-08-07 21:00:00, 431.5
2018-08-11 03:00:00,2018-08-13 20:00:00,2018-08-11 18:00:00, 459.7
2018-08-14 21:00:00,2018-08-17 21:00:00,2018-08-16 11:00:00, 510.4
2018-08-20 01:00:00,2018-08-26 14:00:00,2018-08-21 20:00:00, 561.9
2018-08-30 07:00:00,2018-08-31 07:00:00,2018-08-30 19:00:00, 424.4
2018-09-06 22:00:00,2018-09-13 14:00:00,2018-09-10 19:00:00, 546.9
2018-09-16 15:00:00,2018-09-20 16:00:00,2018-09-17 15:00:00, 555.0
2018-10-04 00:00:00,2018-10-10 11:00:00,2018-10-08 11:00:00, 596.1
2018-10-14 00:00:00,2018-10-16 20:00:00,2018-10-14 15:00:00, 541.3
2018-10-23 21:00:00,2018-10-26 04:00:00,2018-10-23 22:00:00, 468.9
2018-10-30 23:00:00,2018-10-31 23:00:00,2018-10-31 15:00:00, 418.2
2018-11-03 02:00:00,2018-11-07 02:00:00,2018-11-04 11:00:00, 585.2
2018-11-10 23:00:00,2018-11-15 00:00:00,2018-11-11 08:00:00, 521.0
2018-11-22 05:00:00,2018-11-23 04:00:00,2018-11-22 07:00:00, 456.9
2018-11-30 15:00:00,2018-12-03 19:00:00,2018-12-01 08:00:00, 501.5
2018-12-07 12:00:00,2018-12-12 06:00:00,2018-12-10 03:00:00, 563.3
2018-12-19 15:00:00,2018-12-20 21:00:00,2018-12-19 22:00:00, 448.4
2018-12-27 17:00:00,2018-12-31 08:00:00,2018-12-28 23:00:00, 509.6
2019-01-03 12:00:00,2019-01-08 00:00:00,2019-01-04 22:00:00, 561.9
2019-01-23 08:00:00,2019-01-26 19:00:00,2019-01-23 22:00:00, 541.9
2019-01-30 18:00:00,2019-02-04 17:00:00,2019-01-31 15:00:00, 586.9
2019-02-08 13:00:00,2019-02-11 17:00:00,2019-02-09 15:00:00, 465.6
2019-02-26 14:00:00,2019-03-03 20:00:00,2019-03-01 11:00:00, 510.4
2019-03-04 14:00:00,2019-03-05 14:00:00,2019-03-05 08:00:00, 411.5
2019-03-29 16:00:00,2019-03-30 17:00:00,2019-03-30 13:00:00, 406.7
2019-04-04 16:00:00,2019-04-08 18:00:00,2019-04-04 23:00:00, 474.3
2019-04-24 00:00:00,2019-04-27 08:00:00,2019-04-24 21:00:00, 441.4
2019-04-30 20:00:00,2019-05-03 22:00:00,2019-05-01 10:00:00, 503.2
2019-05-28 12:00:00,2019-05-30 23:00:00,2019-05-29 05:00:00, 449.8
2019-06-12 17:00:00,2019-06-14 12:00:00,2019-06-13 19:00:00, 418.8
2019-06-26 02:00:00,2019-06-28 10:00:00,2019-06-27 00:00:00, 460.8
2019-07-05 03:00:00,2019-07-11 18:00:00,2019-07-09 16:00:00, 458.3
2019-07-31 16:00:00,2019-08-03 10:00:00,2019-08-01 05:00:00, 468.9
2019-08-04 02:00:00,2019-08-08 03:00:00,2019-08-05 17:00:00, 566.9
2019-08-10 10:00:00,2019-08-12 09:00:00,2019-08-11 01:00:00, 485.5
2019-08-27 12:00:00,2019-09-04 12:00:00,2019-09-01 00:00:00, 616.5
2019-09-07 06:00:00,2019-09-09 15:00:00,2019-09-07 11:00:00, 509.2
2019-09-17 04:00:00,2019-09-18 14:00:00,2019-09-17 16:00:00, 417.9
2019-09-24 21:00:00,2019-09-26 01:00:00,2019-09-25 02:00:00, 444.1
2019-09-27 04:00:00,2019-10-01 00:00:00,2019-09-28 02:00:00, 590.3
2019-10-20 13:00:00,2019-10-22 22:00:00,2019-10-21 07:00:00, 489.7
2019-10-24 05:00:00,2019-10-28 20:00:00,2019-10-25 22:00:00, 625.9
2019-10-31 09:00:00,2019-11-02 04:00:00,2019-10-31 19:00:00, 468.0
2019-11-16 21:00:00,2019-11-19 00:00:00,2019-11-16 22:00:00, 495.4
2019-11-21 14:00:00,2019-11-23 23:00:00,2019-11-22 01:00:00, 457.0
2019-11-27 18:00:00,2019-11-30 01:00:00,2019-11-28 02:00:00, 507.6
2019-12-18 07:00:00,2019-12-20 15:00:00,2019-12-18 13:00:00, 479.6
2020-01-08 17:00:00,2020-01-10 23:00:00,2020-01-09 13:00:00, 452.7
2020-01-15 05:00:00,2020-01-16 10:00:00,2020-01-16 05:00:00, 413.8
2020-02-10 21:00:00,2020-02-13 01:00:00,2020-02-12 03:00:00, 459.8
2020-03-30 11:00:00,2020-04-01 01:00:00,2020-03-31 06:00:00, 423.0
2020-04-11 03:00:00,2020-04-12 09:00:00,2020-04-11 04:00:00, 428.4
2020-05-19 11:00:00,2020-05-20 19:00:00,2020-05-19 15:00:00, 428.5
2020-07-23 19:00:00,2020-07-25 08:00:00,2020-07-24 02:00:00, 435.8
2020-08-03 07:00:00,2020-08-05 01:00:00,2020-08-03 10:00:00, 469.5
2020-09-29 19:00:00,2020-10-02 10:00:00,2020-09-30 09:00:00, 482.2
2020-10-21 08:00:00,2020-10-22 15:00:00,2020-10-21 14:00:00, 422.5
2020-11-07 22:00:00,2020-11-09 09:00:00,2020-11-08 01:00:00, 473.0
2020-11-13 06:00:00,2020-11-15 14:00:00,2020-11-14 19:00:00, 467.4
2020-11-22 07:00:00,2020-11-25 05:00:00,2020-11-23 01:00:00, 489.3
`;